import EventEmitter from 'events';

const cartEventEmitter = new EventEmitter();

export default cartEventEmitter;
